module.exports = __webpack_public_path__ + "static/img/top_logo_icon.7449b16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/top_logo_icon.svg
// module id = YYBp
// module chunks = 33